import { ToggleButton } from "@aws-amplify/ui-react"

const CatalogGroupMenu = ({
    currentGroup,
    onGroupChange,
    language
}) => {
    const groups = [
        { "en": "Chest", "ru": "Грудь" },
        { "en": "Back", "ru": "Спина" },
        { "en": "Shoulders", "ru": "Плечи" },
        { "en": "Biceps", "ru": "Бицепс" },
        { "en": "Triceps", "ru": "Трицепс" },
        { "en": "Forearms", "ru": "Предплечье" },
        { "en": "Quads", "ru": "Квадрицепс" },
        { "en": "Glutes", "ru": "Ягодицы" },
        { "en": "Hamstrings", "ru": "Бедро" },
        { "en": "Core", "ru": "Кор" },
        { "en": "Calves", "ru": "Икры" }]
    return (
        <div className="d-flex">
            {
                groups.map((value, index, array) =>
                    <ToggleButton
                        variation="primary"
                        className="m-1"
                        key={index}
                        isPressed={currentGroup === value["en"].toLowerCase()}
                        onChange={() => {
                            onGroupChange(value["en"].toLowerCase())
                        }}>
                        {value[language]}
                    </ToggleButton>)
            }
        </div>
    )
}

export default CatalogGroupMenu